import React from 'react'
import DataSource from '../DataSource'
import Tab from '../components/Tab'
import Heading from '../components/Heading'

class MobileCoverage extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            title: '',
            description: ''
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getContent/mobile/coverage', response => {
            this.setState({
                ...response,
                isLoaded: true
            })
        })
    }

    render () {
        return (
            <Tab className='coverage-map' isLoaded={this.state.isLoaded}>
                <Heading title={this.state.title} description={this.state.description} className='text-center' />
                <div className='w-100 d-flex justify-content-center'>
                    <iframe
                        className="tw-coveragemap"
                        width="1000"
                        height="730"
                        allow="geolocation"
                        src="https://mobilemaps.net.au/api/map-ui/v1/index.html?key=fSyR9S4XVhYGZhwDqw4Dy7DXh7SqUxg7&mode=wholesale&mmwave=true"
                        style={{ display: 'block', margin: '0px auto !important', border: 'none' }}
                    />
                </div>
                <div className='row my-5 text-center'>
                    <div className='col-12 col-lg-8 offset-lg-2'>
                        For more information, please refer to our <a href='/terms'>Terms of Use</a>.
                    </div>
                </div>
            </Tab>
        )
    }
}

export default MobileCoverage



// WEBPACK FOOTER //
// ./resources/js/mobile/MobileCoverage.js